const OpinionData = [
    {
        content: "Idąc do gabinetu pierwszy raz czułam się trochę skrępowana, ale szybko mi to minęło gdy tylko zaczęłam " +
            "rozmawiać z panią podolog. Pani tłumaczy bardzo zrozumiale i widać że ma dużą wiedzę. Cierpliwie odpowiedziała " +
            "na wszystkie moje pytania. Do tego jest bardzo symatyczna. Jestem bardzo zadowolona z wizyty w gabinecie.",
        author: "Beata (Kielce)"
    },
    {
        content: "Zdecydowanie jestem na tak! Zabieg refleksologii jest czymś niesamowitym. Pomaga uwolnić spięcie. " +
            "Stopy noszą nas całe życie więc warto o nich pamiętać w szczególności, że poprzez właśnie stopy pozbywamy się " +
            "dolegliwości w innych partiach naszego ciała. Reguralne uczęszczanie na terapię potrafi zdziałać cuda.",
        author: "Iwona (Busko-Zdrój)"
    },
    {
        content: "Zabiegi polecam wszystkim cierpiącym na dolegliwości mięśniowo-kostno-stawowe. Przyspieszają dojście " +
            "do siebie po kontuzjach i redukują ból. Jak raz spróbujecie, będziecie już stałymi klientami.",
        author: "Marcin (Kielce)"
    },
    {
        content: "Ilonka to osoba o niezwykłej otwartości i wrażliwości, pełna pozytywnej energii. Do każdego zabiegu " +
            "podchodzi w pełni zaangażowana. Leczy nie tylko ciało, ale i duszę. Ma ogromną wiedzę, którą potrafi " +
            "wykorzystać i przekazać, by nasz organizm \"działał\" w 100%. Polecam ją całym sercem.",
        author: "Ewelina (Kielce)"
    },
    {
        content: "Korzystałam z zabiegów refleksologii kilkukrotnie. Uzdrowiły moje ciało, pomogły uwolnić emocje " +
            "gromadzone przez lata. Nigdy wcześniej nie byłam tak odprężona i zrelaksowana. Ilona to bardzo miła, " +
            "wrażliwa a przede wszystkim niezwykle fachowa osoba, wykonuje swoją pracę z wielką pasją i zanagażowaniem. " +
            "Jest najwaspanialszą uzdrowicielką ciała i duszy jaką znam. Szczerze polecam.",
        author: "Monika (Kielce)"
    }
];

export default OpinionData;